import { Component, inject, Input } from '@angular/core';
import { CreativeGalleryBase } from '../../types';
import { ShortNumberPipe } from '../../../../pipes/short-number.pipe';
import { PercentagePipe } from '../../../../pipes/percentage.pipe';
import { CardPopoverComponent } from './card-popover/card-popover.component';
import { NgIf } from '@angular/common';
import { CopilotService } from '../../../../services/copilot.service';
import { ATTENTION_METRIC_NAME } from '../../../../shared/types/common';

@Component({
  selector: 'app-creative-gallery-card',
  imports: [CardPopoverComponent, NgIf, PercentagePipe],
  providers:[ShortNumberPipe, PercentagePipe],
  templateUrl: './creative-gallery-card.component.html',
  styleUrl: './creative-gallery-card.component.scss'
})
export class CreativeGalleryCardComponent {
  @Input() cardData!: CreativeGalleryBase;
  public isHovered = false;
  public isLogoHovered = false;
  protected readonly copilotMessage = "What's driving this creative’s performance, and how does it compare to the advertiser’s other creatives?";
  protected cpm!: string;
  public attentionMetricName = ATTENTION_METRIC_NAME; 
  private copilotService = inject(CopilotService);

  ngOnInit(): void {
    this.cpm = `$${this.cardData?.cpm.toFixed(2) || '0.00'}`;
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'images/no-logo.png';
  }

  onAskCopilotClick(event: MouseEvent) {
    event.stopPropagation(); // prevents the card click
    const message = `${this.copilotMessage} Creative id is ${this.cardData.imgUrl}`;
    this.copilotService.triggerMessage(message);
  }
}
